<template>
  <v-dialog
    persistent
    scrollable
    :value="value"
    max-width="480"
    @input="$emit('input', $event)"
  >
    <v-card class="pa-3">
      <div class="font-weight-medium">
        These absences would be left without a matching schedule.
      </div>
      <div class="mt-2">
        Nothing is moved automatically. The absences stay where they are, and
        their pay deductions stay as they are, until you delete or edit them.
        Take care of these first, then change the schedule.
      </div>

      <div
        class="mt-3 pa-2"
        style="overflow-y: auto; max-height: 240px; border: 1px solid #e0e0e0;"
      >
        <div v-for="absent in absents" :key="absent.absentID" class="mb-2">
          <div class="font-weight-medium">
            {{ formatDate(absent.date) }}
            <span v-if="absent.driver">— {{ absent.driver }}</span>
          </div>
          <div class="caption grey--text">
            {{
              [absent.timeStart, absent.routeIdentifier, absent.buildings]
                .filter(Boolean)
                .join(" · ")
            }}
          </div>
        </div>
      </div>

      <v-card-actions class="mr-0 mt-3">
        <v-spacer></v-spacer>
        <v-btn color="default" dark @click="$emit('input', false)">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";

export default {
  props: {
    value: Boolean,
    absents: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    formatDate(date) {
      return date ? moment(date).format("M/D/YYYY") : "";
    },
  },
};
</script>
